import routes from './routes';
import { SetRoutes } from 'components';

const QRPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default QRPages;
